export default __webpack_public_path__ + "assets/red-arrow.svg";